import React, { useState, useEffect, useRef } from "react";
import SideBar from "../SideBar/SideBar";
import Images from "../../Assets/Images";
import { Cross, PlusCircle, XCircle } from "lucide-react";
import Footer from "../Footer/Footer";
import "./Appearance.css";
import Api from "../../Api/Api";
import Header from "../Header/Header";
function Appearance() {
  const [image, setImage] = useState(null);
  const [template, setTemplate] = useState([]);
  const fileInputRef = useRef(null);
  const handleFileSelect = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
    }
  };

  useEffect(() => {
    Api.api("http://192.168.0.110:8000/admin_api/templates").then((data) =>
      setTemplate(data.rows)
    );
  }, []);

  return (
    <div>
      <SideBar />
      <Header value={{ name: "Appearance" }} />
      <div className="menu-card-con">
        <div className="menu-card">
          <div className="appearance-container">
            <div className="profile-container">
              <h3 style={{ color: "black" }}>profile</h3>
              <div className="profile-card">
                <div className="image-con">
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                  {image ? (
                    <img src={image} alt="Preview" className="preview-img" />
                  ) : (
                    <img
                      src={Images.ava3}
                      alt="Default Avatar"
                      className="preview-img"
                    />
                  )}
                </div>
                <div className="profile-details m-3">
                  <button className="btn-profile" onClick={handleFileSelect}>
                    Edit Image
                  </button>
                  <button className="btn-profile">Edit Display Name</button>
                  <button className="btn-profile">Edit Display Bio</button>
                </div>
              </div>
            </div>
            <div className="template mt-3">
              <h3 style={{ color: "black" }}>Template</h3>
              <div className="template-container">
                {template.map((tem, index) => (
                  <div key={index} className="app-tem-container">
                    <img src={tem.image} alt="Template" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className=" menu-card-preview ">
          <iframe src="https://www.falconsqr.com/"></iframe>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Appearance;
